export default __webpack_public_path__ + "static/media/chinese.632cd1c7.jpg";